'use client';

import {
  ChatIcon,
  ContactsIcon,
  JobsIcon,
  MeIcon,
  QuickTasksIcon,
  ReportingIcon,
  SettingsIcon,
} from '@/ui/atomic-organisms/Navigation/icons';
import { ContextTabs } from '@web/ui';

import { useContextTabsContext } from '../context/ContextTabsContext';

import type { ContextTab } from '@web/hooks';

export function getContextTabIcon(
  iconKey: string | undefined,
  active: boolean,
) {
  switch (iconKey) {
    case 'me':
    case 'profile':
      return <MeIcon active={active} />;
    case 'contacts':
      return <ContactsIcon active={active} />;
    case 'jobs':
      return <JobsIcon active={active} />;
    case 'quick-tasks':
      return <QuickTasksIcon active={active} />;
    case 'chat':
      return <ChatIcon active={active} />;
    case 'performance':
      return <ReportingIcon active={active} />;
    case 'settings':
      return <SettingsIcon active={active} />;
    default:
      return null;
  }
}

export function getContextTabFullLabel(
  tab: Pick<ContextTab, 'url' | 'area' | 'name' | 'section' | 'contextLabel'>,
) {
  const parts = [tab.name, tab.contextLabel, tab.section];
  return [...new Set(parts.filter(Boolean))].join(' • ');
}

export function getVisibleContextTabId(
  activeTabId: string,
  currentRouteTabId?: string,
) {
  return currentRouteTabId ?? activeTabId;
}

export function ContextTabsController() {
  const context = useContextTabsContext();
  if (!context) return null;
  const visibleActiveTabId = getVisibleContextTabId(
    context.snapshot.activeTabId,
    context.currentRouteTabId,
  );

  return (
    <ContextTabs
      tabs={context.snapshot.tabs.map((tab) => ({
        id: tab.id,
        name: tab.name,
        section: tab.section,
        fullLabel: getContextTabFullLabel(tab),
        icon: getContextTabIcon(tab.iconKey, tab.id === visibleActiveTabId),
        isDirty: tab.isDirty,
      }))}
      activeTabId={visibleActiveTabId}
      displayMode="section"
      canAdd={context.canAddTab}
      onSelect={context.selectContextTab}
      onClose={context.closeContextTab}
      onAdd={context.createContextTab}
    />
  );
}
